// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewInquiry-commonHeaderAdmin-m5AQG {
	position: fixed !important;
}

.ViewInquiry-adminLayout-lCCBP {
	padding-top: 64px !important;
}

.ViewInquiry-box-I2i0_ h2 {
	font-size: 21px;
	font-weight: 600;
}

.ViewInquiry-exportLink-NUlp8 {
	margin-bottom: -29px;
}

.ViewInquiry-blockCenter-iBjzK {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.ViewInquiry-panelHeader-Tt8x_ {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.ViewInquiry-currencyselect-EpIv3 {
	width: 100%;
	margin-right: 0px;
}

.ViewInquiry-panelHeader-Tt8x_ {
	overflow: hidden;
	position: relative;
}

.ViewInquiry-mar0-jsasj {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.ViewInquiry-blockCenter-iBjzK {
		padding: 0px;
	}

	.ViewInquiry-panelHeader-Tt8x_ {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.ViewInquiry-sideAdminPageWrapper-Pk7iH {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.ViewInquiry-panelHeader-Tt8x_ {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.ViewInquiry-table-mrdjT {
	display: table;
}

.ViewInquiry-tableRow-cUTgz {
	display: table-row;
}

.ViewInquiry-tableCell-wR1Bg {
	display: table-cell;
	float: none;
}

.ViewInquiry-formGroup-Ve0fd {
	margin-bottom: 6px;
}

.ViewInquiry-select-WGkg5 {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.ViewInquiry-noMargin-CVRPL {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.ViewInquiry-exportLink-NUlp8 {
	padding-top: 10px;
	padding-right: 10px;
}

.ViewInquiry-labelTextNew-Hble0 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.ViewInquiry-displayInline-oQSbP {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.ViewInquiry-btnUPdate-wzX1U {
	display: inline-block;
}

.ViewInquiry-btnModalDelete-cvaWm {
	display: inline-block;
	margin-left: 15px;
}

.ViewInquiry-radioBtn-iDAnn {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.ViewInquiry-backgroundImg-t07Cj {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.ViewInquiry-btnUPdate-wzX1U {
		display: block;
		margin-bottom: 12px;
	}

	.ViewInquiry-btnModalDelete-cvaWm {
		display: block;
		margin-left: 0px;
	}

	.ViewInquiry-btnWidth-dHmBs {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.ViewInquiry-bannerImageBg-f409b {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.ViewInquiry-bannerDelete-PyR1q {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.ViewInquiry-modalRoot-jPtdT {
	padding: 32px;
}

.ViewInquiry-modalBorderBottom-igpjZ {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.ViewInquiry-logInModalBody-vt_Yj {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.ViewInquiry-exportSection-pZDPb {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.ViewInquiry-exportSectionGridSub-AH9bh {
	grid-template-columns: 50% 49% !important;
}

.ViewInquiry-exportText-wlxW7 {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.ViewInquiry-exportLinkImg-CVLXY {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.ViewInquiry-vtrMiddle-shnCq {
	vertical-align: middle;
}

.ViewInquiry-exportImg-TH_l1 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ViewInquiry-profileViewlabel-weAKP {
	display: inline-block;
	width: 38%
}

.ViewInquiry-profileViewMainContent-ucHmw {
	display: inline-block;
	width: 62%;
}

.ViewInquiry-profileViewMain-eIvgZ {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ViewInquiry-profileViewInner-oaFPk {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.ViewInquiry-profileImageSection-GzQF2 {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.ViewInquiry-lastviewInner-BlTi7 {
	padding: 10px;
}

.ViewInquiry-whyHostHoriLine-PSnuh {
	margin: 30px 0;
}

.ViewInquiry-tableGrid-ZIiJ2 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.ViewInquiry-headingContent-zlbUo {
	font-size: 18px;
	font-weight: 500;
}

.ViewInquiry-refundTextColor-ikKGg {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.ViewInquiry-dividerLine-uRegZ {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ViewInquiry-smallContent-x9tj9 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.ViewInquiry-sideAdminPageWrapper-Pk7iH {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.ViewInquiry-sideAdminPageWrapper-Pk7iH {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.ViewInquiry-exportSection-pZDPb {
		grid-template-columns: 100%;
	}

	.ViewInquiry-exportSectionGridSub-AH9bh {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.ViewInquiry-profileViewlabel-weAKP {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ViewInquiry-profileViewMainContent-ucHmw {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.ViewInquiry-ChangeToUpperCase-eNqd3 {
	text-transform: uppercase
}

.ViewInquiry-noBorder-pjOeh {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.ViewInquiry-siteAdminHeading-MgPU2 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.ViewInquiry-siteAdminSubHeading-bQiqs {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.ViewInquiry-adminFormDivider-gc3l4 {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.ViewInquiry-space1-aigsQ {
	margin-bottom: 6px !important;
}

.ViewInquiry-space2-jLy96 {
	margin-bottom: 12px !important;
}

.ViewInquiry-space3-GdgbZ {
	margin-bottom: 18px !important;
}

.ViewInquiry-space4-bE7rR {
	margin-bottom: 24px !important;
}

.ViewInquiry-space5-K0zft {
	margin-bottom: 30px !important;
}

.ViewInquiry-space6-cRdS1 {
	margin-bottom: 36px !important;
}

.ViewInquiry-space7-qTXLB {
	margin-bottom: 42px !important;
}

.ViewInquiry-spaceTop8-VLed7 {
	margin-bottom: 48px !important;
}

.ViewInquiry-spaceTop1-rTevk {
	margin-top: 6px !important;
}

.ViewInquiry-spaceTop2-bco2G {
	margin-top: 12px !important;
}

.ViewInquiry-spaceTop3-gytUe {
	margin-top: 18px !important;
}

.ViewInquiry-spaceTop4-GRIUC {
	margin-top: 24px !important;
}

.ViewInquiry-spaceTop5-eni6U {
	margin-top: 30px !important;
}

.ViewInquiry-spaceTop6-Ekgd6 {
	margin-top: 36px !important;
}

.ViewInquiry-spaceTop7-N1p6L {
	margin-top: 42px !important;
}

.ViewInquiry-spaceTop8-VLed7 {
	margin-top: 48px !important;
}

.ViewInquiry-noMargin-CVRPL {
	margin: 0px !important;
}

.ViewInquiry-padding1-g4fgf {
	padding-bottom: 6px !important;
}

.ViewInquiry-padding2-zip2y {
	padding-bottom: 12px !important;
}

.ViewInquiry-padding3-uydlM {
	padding-bottom: 18px !important;
}

.ViewInquiry-padding4-cIr_9 {
	padding-bottom: 24px !important;
}

.ViewInquiry-padding5-mHTOz {
	padding-bottom: 30px !important;
}

.ViewInquiry-padding6-TUGRz {
	padding-bottom: 36px !important;
}

.ViewInquiry-padding7-s3_2f {
	padding-bottom: 42px !important;
}

.ViewInquiry-paddingTop1-NgzU5 {
	padding-top: 6px !important;
}

.ViewInquiry-paddingTop2-xqUJ7 {
	padding-top: 12px !important;
}

.ViewInquiry-paddingTop3-FfQqH {
	padding-top: 18px !important;
}

.ViewInquiry-paddingTop4-Tfl8Z {
	padding-top: 24px !important;
}

.ViewInquiry-paddingTop5-S8VIE {
	padding-top: 30px !important;
}

.ViewInquiry-paddingTop6-_ZR7K {
	padding-top: 36px !important;
}

.ViewInquiry-paddingTop7-jkTyS {
	padding-top: 42px !important;
}

.ViewInquiry-noPadding-Tj39h {
	padding: 0px !important;
}

.ViewInquiry-textBold-hlNwf {
	font-weight: 500 !important;
}

.ViewInquiry-textBolder-wEW4c {
	font-weight: 700 !important;
}

.ViewInquiry-textNormal-VToje {
	font-weight: normal !important;
}

.ViewInquiry-spaceBottom20-T5uQL {
	margin-bottom: 20px;
}

.ViewInquiry-spaceBottom10-Fcs5v {
	margin-bottom: 10px;
}

.ViewInquiry-marginNone-iFtT8 {
	margin: 0;
}

.ViewInquiry-spaceBottom15-n0hG7 {
	margin-bottom: 15px;
}

.ViewInquiry-marginTopNone-GTz8t {
	margin-top: 0;
}

.ViewInquiry-spaceTop11-AFp5M {
	margin-top: 11px;
}

.ViewInquiry-spaceTop21-dPPtc {
	margin-top: 21px;
}

.ViewInquiry-spaceTop20-uSTh8 {
	margin-top: 20px;
}

.ViewInquiry-spaceTop10-fSjeB {
	margin-top: 10px;
}

/*New Design Text Colors */

.ViewInquiry-textDarkBlue-SzBHC {
	color: rgb(20, 39, 94) !important;
}

.ViewInquiry-textLightBlue-PHr8Z {
	color: rgb(57, 87, 106) !important;
}

.ViewInquiry-textLightSandleGreen-DkKsD {
	color: rgb(76, 86, 41) !important;
}

.ViewInquiry-textLightBrown-abV7E {
	color: rgb(115, 79, 33) !important;
}

.ViewInquiry-textMediumMaroon-zZn1Y {
	color: rgb(87, 37, 51) !important;
}

.ViewInquiry-textBrown-yZvEc {
	color: rgb(160, 47, 24) !important;
}

.ViewInquiry-textMaroon-dDD20 {
	color: rgb(155, 49, 67) !important;
}

.ViewInquiry-textDarkBrown-PFeOl {
	color: rgb(83, 18, 16) !important;
}

.ViewInquiry-textMediumBrown-FaTS_ {
	color: rgb(142, 28, 10) !important;
}

.ViewInquiry-textSkyBlue-qQkR4 {
	color: rgb(37, 117, 141) !important;
}

.ViewInquiry-textGray-_odSw {
	color: rgb(77, 65, 51) !important;
}

.ViewInquiry-capitalize-NHsWI {
	text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/ViewInquiry/ViewInquiry.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACzNA;CACC,0BAA0B;AAC3B","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../../helpers.css';\n\n.capitalize {\n\ttext-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `ViewInquiry-commonHeaderAdmin-m5AQG`,
	"adminLayout": `ViewInquiry-adminLayout-lCCBP`,
	"box": `ViewInquiry-box-I2i0_`,
	"exportLink": `ViewInquiry-exportLink-NUlp8`,
	"blockCenter": `ViewInquiry-blockCenter-iBjzK`,
	"panelHeader": `ViewInquiry-panelHeader-Tt8x_`,
	"currencyselect": `ViewInquiry-currencyselect-EpIv3`,
	"mar0": `ViewInquiry-mar0-jsasj`,
	"sideAdminPageWrapper": `ViewInquiry-sideAdminPageWrapper-Pk7iH`,
	"table": `ViewInquiry-table-mrdjT`,
	"tableRow": `ViewInquiry-tableRow-cUTgz`,
	"tableCell": `ViewInquiry-tableCell-wR1Bg`,
	"formGroup": `ViewInquiry-formGroup-Ve0fd`,
	"select": `ViewInquiry-select-WGkg5`,
	"noMargin": `ViewInquiry-noMargin-CVRPL`,
	"labelTextNew": `ViewInquiry-labelTextNew-Hble0`,
	"displayInline": `ViewInquiry-displayInline-oQSbP`,
	"btnUPdate": `ViewInquiry-btnUPdate-wzX1U`,
	"btnModalDelete": `ViewInquiry-btnModalDelete-cvaWm`,
	"radioBtn": `ViewInquiry-radioBtn-iDAnn`,
	"backgroundImg": `ViewInquiry-backgroundImg-t07Cj`,
	"btnWidth": `ViewInquiry-btnWidth-dHmBs`,
	"bannerImageBg": `ViewInquiry-bannerImageBg-f409b`,
	"bannerDelete": `ViewInquiry-bannerDelete-PyR1q`,
	"modalRoot": `ViewInquiry-modalRoot-jPtdT`,
	"modalBorderBottom": `ViewInquiry-modalBorderBottom-igpjZ`,
	"logInModalBody": `ViewInquiry-logInModalBody-vt_Yj`,
	"exportSection": `ViewInquiry-exportSection-pZDPb`,
	"exportSectionGridSub": `ViewInquiry-exportSectionGridSub-AH9bh`,
	"exportText": `ViewInquiry-exportText-wlxW7`,
	"exportLinkImg": `ViewInquiry-exportLinkImg-CVLXY`,
	"vtrMiddle": `ViewInquiry-vtrMiddle-shnCq`,
	"exportImg": `ViewInquiry-exportImg-TH_l1`,
	"profileViewlabel": `ViewInquiry-profileViewlabel-weAKP`,
	"profileViewMainContent": `ViewInquiry-profileViewMainContent-ucHmw`,
	"profileViewMain": `ViewInquiry-profileViewMain-eIvgZ`,
	"profileViewInner": `ViewInquiry-profileViewInner-oaFPk`,
	"profileImageSection": `ViewInquiry-profileImageSection-GzQF2`,
	"lastviewInner": `ViewInquiry-lastviewInner-BlTi7`,
	"whyHostHoriLine": `ViewInquiry-whyHostHoriLine-PSnuh`,
	"tableGrid": `ViewInquiry-tableGrid-ZIiJ2`,
	"headingContent": `ViewInquiry-headingContent-zlbUo`,
	"refundTextColor": `ViewInquiry-refundTextColor-ikKGg`,
	"dividerLine": `ViewInquiry-dividerLine-uRegZ`,
	"smallContent": `ViewInquiry-smallContent-x9tj9`,
	"ChangeToUpperCase": `ViewInquiry-ChangeToUpperCase-eNqd3`,
	"noBorder": `ViewInquiry-noBorder-pjOeh`,
	"siteAdminHeading": `ViewInquiry-siteAdminHeading-MgPU2`,
	"siteAdminSubHeading": `ViewInquiry-siteAdminSubHeading-bQiqs`,
	"adminFormDivider": `ViewInquiry-adminFormDivider-gc3l4`,
	"space1": `ViewInquiry-space1-aigsQ`,
	"space2": `ViewInquiry-space2-jLy96`,
	"space3": `ViewInquiry-space3-GdgbZ`,
	"space4": `ViewInquiry-space4-bE7rR`,
	"space5": `ViewInquiry-space5-K0zft`,
	"space6": `ViewInquiry-space6-cRdS1`,
	"space7": `ViewInquiry-space7-qTXLB`,
	"spaceTop8": `ViewInquiry-spaceTop8-VLed7`,
	"spaceTop1": `ViewInquiry-spaceTop1-rTevk`,
	"spaceTop2": `ViewInquiry-spaceTop2-bco2G`,
	"spaceTop3": `ViewInquiry-spaceTop3-gytUe`,
	"spaceTop4": `ViewInquiry-spaceTop4-GRIUC`,
	"spaceTop5": `ViewInquiry-spaceTop5-eni6U`,
	"spaceTop6": `ViewInquiry-spaceTop6-Ekgd6`,
	"spaceTop7": `ViewInquiry-spaceTop7-N1p6L`,
	"padding1": `ViewInquiry-padding1-g4fgf`,
	"padding2": `ViewInquiry-padding2-zip2y`,
	"padding3": `ViewInquiry-padding3-uydlM`,
	"padding4": `ViewInquiry-padding4-cIr_9`,
	"padding5": `ViewInquiry-padding5-mHTOz`,
	"padding6": `ViewInquiry-padding6-TUGRz`,
	"padding7": `ViewInquiry-padding7-s3_2f`,
	"paddingTop1": `ViewInquiry-paddingTop1-NgzU5`,
	"paddingTop2": `ViewInquiry-paddingTop2-xqUJ7`,
	"paddingTop3": `ViewInquiry-paddingTop3-FfQqH`,
	"paddingTop4": `ViewInquiry-paddingTop4-Tfl8Z`,
	"paddingTop5": `ViewInquiry-paddingTop5-S8VIE`,
	"paddingTop6": `ViewInquiry-paddingTop6-_ZR7K`,
	"paddingTop7": `ViewInquiry-paddingTop7-jkTyS`,
	"noPadding": `ViewInquiry-noPadding-Tj39h`,
	"textBold": `ViewInquiry-textBold-hlNwf`,
	"textBolder": `ViewInquiry-textBolder-wEW4c`,
	"textNormal": `ViewInquiry-textNormal-VToje`,
	"spaceBottom20": `ViewInquiry-spaceBottom20-T5uQL`,
	"spaceBottom10": `ViewInquiry-spaceBottom10-Fcs5v`,
	"marginNone": `ViewInquiry-marginNone-iFtT8`,
	"spaceBottom15": `ViewInquiry-spaceBottom15-n0hG7`,
	"marginTopNone": `ViewInquiry-marginTopNone-GTz8t`,
	"spaceTop11": `ViewInquiry-spaceTop11-AFp5M`,
	"spaceTop21": `ViewInquiry-spaceTop21-dPPtc`,
	"spaceTop20": `ViewInquiry-spaceTop20-uSTh8`,
	"spaceTop10": `ViewInquiry-spaceTop10-fSjeB`,
	"textDarkBlue": `ViewInquiry-textDarkBlue-SzBHC`,
	"textLightBlue": `ViewInquiry-textLightBlue-PHr8Z`,
	"textLightSandleGreen": `ViewInquiry-textLightSandleGreen-DkKsD`,
	"textLightBrown": `ViewInquiry-textLightBrown-abV7E`,
	"textMediumMaroon": `ViewInquiry-textMediumMaroon-zZn1Y`,
	"textBrown": `ViewInquiry-textBrown-yZvEc`,
	"textMaroon": `ViewInquiry-textMaroon-dDD20`,
	"textDarkBrown": `ViewInquiry-textDarkBrown-PFeOl`,
	"textMediumBrown": `ViewInquiry-textMediumBrown-FaTS_`,
	"textSkyBlue": `ViewInquiry-textSkyBlue-qQkR4`,
	"textGray": `ViewInquiry-textGray-_odSw`,
	"capitalize": `ViewInquiry-capitalize-NHsWI`
};
module.exports = ___CSS_LOADER_EXPORT___;
